import { get, post } from './index';

export const checkAuth = () => get('/api/v1/admin/auth/status');

export const login = param => post('/api/v1/admin/auth/login', param);

export const logout = () => post('/api/v1/admin/auth/logout');

export const resetPassword = param => post('/api/v1/admin/auth/reset-password', param);
